module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ApplicationResourcesView.js"));
	}, "applicationResourcesView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=applicationResourcesView!./src/pages/ResourceManage/ApplicationResources/ApplicationResourcesView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=applicationResourcesView!./src/pages/ResourceManage/ApplicationResources/ApplicationResourcesView.js
// module chunks = 43